import React from 'react';
import * as _ from 'lodash';
import { PropTypes } from 'prop-types';
import CustomIcon from '../../CustomIcon';
import MosaicItem from './MosaicItem';

export const AVATAR_SELECTOR_REVEAL = 'avatarSelectorReveal';

export default class AvatarMosaic extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.selectAvatar = this.selectAvatar.bind(this);
    this.openFileBrowser = this.openFileBrowser.bind(this);
  }

  static propTypes = {
    itemClass: PropTypes.string,
    selectedImage: PropTypes.string,
    selectAvatarCallback: PropTypes.func,
    images: PropTypes.object,
    closeModal: PropTypes.func,
    classroomPicture: PropTypes.number,
    classroomAsset: PropTypes.string,
    selectImageToCrop: PropTypes.func
  };

  selectAvatar = (event, image) => {
    const { selectAvatarCallback, closeModal } = this.props;
    selectAvatarCallback(image);
    closeModal(event);
  };

  openFileBrowser = e => {
    this.fileUploader.click();
  };

  onChangeFile = event => {
    const { selectImageToCrop } = this.props;

    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];
    selectImageToCrop(file);
  };

  getUserPictures = () => {
    const { selectedImage, images, itemClass } = this.props;

    let avatarsToRender = [this.renderPlusAvatar()];
    if (images) {
      if (selectedImage) {
        avatarsToRender.push(this.renderSelectedImage(selectedImage));
      }
      _.forOwn(images, (avatarUrl, index) => {
        avatarsToRender.push(
          <MosaicItem
            key={index}
            itemClass={itemClass}
            selectedImage={selectedImage}
            imageUrl={avatarUrl}
            imageId={index}
            selectImage={this.selectAvatar}
          />
        );
      });
    }
    return avatarsToRender;
  };

  renderSelectedImage = urlImage => {
    const { itemClass, classroomAsset } = this.props;

    // TODO: remove isNAN check when user profile assets management will be refactored
    if (classroomAsset && isNaN(parseInt(urlImage, 10))) {
      return (
        <MosaicItem
          key={-2}
          itemClass={itemClass}
          selectedImage={urlImage}
          imageUrl={urlImage}
          imageId={urlImage}
          selectImage={this.selectAvatar}
        />
      );
    }
  };

  renderPlusAvatar = () => {
    const { itemClass } = this.props;

    return (
      <div key={-1} className={`dashed-image-selector ${itemClass}`} onClick={this.openFileBrowser}>
        <CustomIcon size={30} name="plus-button" />
        <input
          type="file"
          onChange={this.onChangeFile.bind(this)}
          accept="image/x-png,image/gif,image/jpeg"
          ref={ref => (this.fileUploader = ref)}
          className="image-input"
        />
      </div>
    );
  };

  render() {
    return this.getUserPictures();
  }
}
